'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const Route = require('common/route');
const VersionListView = require('data/ui/view/content/version-list');
const PDFPreviewerView = require('data/ui/view/content/pdf-previewer');
const ActionListView = require('process/ui/view/action/list');
const StorageAPI = require('data/infra/api/storage/index');
const ContentActionWorkRepository = require('balus/infra/repository/actionwork/content');
const NodeContentAllocationRepository = require('balus/infra/repository/allocation/node-content');
const DiagramRepository = require('system/domain/repository/diagram');
const NodeItemTemplate = require('balus/ui/template/body/data-content/content/node-item.hbs');
const Template = require('balus/ui/template/body/data-content/content/index.hbs');

const NodeItemView = Mn.View.extend({
    template: NodeItemTemplate,
    templateContext: function() {
        const node = this.model.getModel();
        //TODO: 将来的にはノードの詳細画面に飛ばす
        const diagrams = DiagramRepository.getDiagrams({
            context: {
                projectId: this.getOption('context').getProject().id
            }
        })
            .chain()
            .filter(function(d) {
                return d.hasElement(node);
            })
            .map(function(d) {
                const j = d.toJSON();
                j.url = Route.urlFor(
                    'path:diagram', d.idParams())
                    + Route.urlFor(
                        'diagram:element', {id: node.id});
                return j;
            }, this)
            .value();

        return {
            name: node.getName() ? node.getName() : 'No Name',
            type: node.i18nType(),
            diagram: diagrams ?
                diagrams[0] :
                null
        };
    }
});

const NodeListView = Mn.CollectionView.extend({
    childView: NodeItemView,
    childViewOptions: function() {
        return {
            context: this.getOption('context')
        }
    }
});

module.exports = Mn.View.extend({
    className: 'content-detail',
    regions: {
        versionList: '.version-list',
        preview: '.preview',
        actionList: '.action-list',
        nodeList: '.node-list',
    },
    template: Template,
    modelEvents: {
        'change': 'render'
    },

    templateContext: function() {
        const latestVersion = this.model.getLatestVersion();
        const hasSize = latestVersion.getMetaData().get('size') > 0;

        return {
            hasPreview: this.model.getLatestVersion().isPDF(),
            dataSource: latestVersion.getDataSource().toJSON(),
            size: latestVersion.prettySizeString(),
            hasSize: hasSize,
            isEmpty: latestVersion.isEmpty()
        }
    },

    onRender: function() {
        if(this.model.isDeleted()) {
            return;
        }

        if (this.model.getLatestVersion().isPDF()) {
            this.showChildView('preview', new PDFPreviewerView({
                model: this.model.getLatestVersion()
            }));
        }

        this.model.getVersions()
            .then(versions => {
                this.showChildView('versionList', new VersionListView({
                    model: this.model,
                    collection: versions
                }));
            });

        ContentActionWorkRepository.find(this.model.getProject())
            .fetchActionWorksByWorkOnce(this.model, 5)
            .then(actionWorks => {
                // Work として登録されていない場合は null が返ってくる
                if(!actionWorks) {
                    return;
                }

                this.showChildView('actionList', new ActionListView({
                    context: this.getOption('context'),
                    model: this.model,
                    collection: new Backbone.Collection(
                        actionWorks.map(aw => aw.getAction())),
                    noChildren: true,
                    emptyViewOptions: function() {
                        return {title: i18n.t('balus_view_body_data-content:content.noAction')}
                    }
                }));
            });

        NodeContentAllocationRepository.find(this.model.getProject())
            .fetchByContent(this.model)
            .then(allocations => {
                this.showChildView('nodeList', new NodeListView({
                    model: this.model,
                    collection: allocations,
                    context: this.getOption('context')
                }));
            });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/data-content/content/index.js